import { render, staticRenderFns } from "./InputType.vue?vue&type=template&id=67c3dfe2&scoped=true&"
import script from "./InputType.vue?vue&type=script&lang=js&"
export * from "./InputType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c3dfe2",
  null
  
)

export default component.exports